import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BankForm from '../../components/forms/BankForm';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useAuth } from '../../contexts/AuthContext';
import { dataHelpers } from '../../lib/supabase';
import toast from 'react-hot-toast';

const BankEditPage = () => {
  const navigate = useNavigate();
  const { bankId } = useParams();
  const { company } = useAuth();
  const [bank, setBank] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (company?.id && bankId) {
      loadBank();
    }
  }, [company, bankId]);

  const loadBank = async () => {
    try {
      setLoading(true);
      
      const bank = await dataHelpers.getBankById(company.id, bankId);
      if (bank) {
        setBank(bank);
      } else {
        toast.error('Banco não encontrado');
        navigate('/dashboard/banks');
      }
    } catch (error) {
      console.error('Error loading bank:', error);
      toast.error('Erro ao carregar dados do banco');
      navigate('/dashboard/banks');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (bankData) => {
    if (!company?.id || !bankId) {
      toast.error('Erro: dados incompletos');
      return;
    }

    try {
      setSaving(true);
      
      console.log('Updating bank with data:', bankData);
      
      await dataHelpers.updateBank(bankId, bankData);
      
      toast.success('Banco atualizado com sucesso!');
      navigate('/dashboard/banks', {
        state: { message: 'Banco atualizado com sucesso!' }
      });
    } catch (error) {
      console.error('Error updating bank:', error);
      toast.error('Erro ao atualizar banco. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard/banks');
  };

  if (loading) {
    return (
      
        <div className="flex items-center justify-center h-64">
          <LoadingSpinner size="large" />
        </div>
      
    );
  }

  if (!bank) {
    return (
      
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <p className="text-gray-500">Banco não encontrado</p>
            <button
              onClick={handleCancel}
              className="mt-4 text-blue-600 hover:text-blue-700"
            >
              Voltar para lista de bancos
            </button>
          </div>
        </div>
      
    );
  }

  return (
    
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center space-x-4">
          <button
            onClick={handleCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Editar Banco</h1>
            <p className="text-gray-600">
              Altere as informações do banco {bank.name}
            </p>
          </div>
        </div>

        {/* Form */}
        <BankForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          initialData={bank}
          loading={saving}
        />
      </div>
    
  );
};

export default BankEditPage;
